module.exports = __webpack_public_path__ + "img/H3.ec673b43.png";